import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { trUri } from '../utils';

const BurgerMenu = ({ items, toggle, lang }) => (
  <div className="burgermenu open">
    <ul className="listburger">
      {items.map((menuitem, i) =>
        <li key={i}><Link
          onClick={toggle}
          to={`/${lang}${trUri(menuitem, lang, '/')}`}
        >
          {menuitem.getIn(['title', lang], menuitem.get('title', '-----'))}</Link>
        </li>
        )}
      <li>
        <p>Contact <span className="prenom">Gaëlle</span></p>
        <p className="tel">+33 3 44 54 04 50</p>
      </li>
    </ul>
  </div>);

BurgerMenu.propTypes = {
  toggle: PropTypes.func.isRequired,
  items: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired,
};

export default BurgerMenu;



// WEBPACK FOOTER //
// ./common/components/BurgerMenu.js